export class InMemoryMyMarinaService {
  createDb() {
    const data: Array<any> = [];

    return { };
  }
}
